import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaLightbulb, FaSearch, FaCode, FaRocket, FaChartBar } from 'react-icons/fa';
import './Process.css';

const Process = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });

  const steps = [
    {
      icon: <FaLightbulb />,
      number: "01",
      title: "Discovery & Consultation",
      description: "We start by understanding your business challenges, goals, and requirements. Our experts conduct a thorough analysis of your current processes.",
      duration: "1-2 weeks"
    },
    {
      icon: <FaSearch />,
      number: "02",
      title: "Analysis & Planning",
      description: "We analyze your data, identify automation opportunities, and create a detailed roadmap with clear milestones and deliverables.",
      duration: "2-3 weeks"
    },
    {
      icon: <FaCode />,
      number: "03",
      title: "Development & Integration",
      description: "Our team develops custom AI solutions tailored to your needs and seamlessly integrates them with your existing systems.",
      duration: "4-6 weeks"
    },
    {
      icon: <FaRocket />,
      number: "04",
      title: "Testing & Deployment",
      description: "Rigorous testing ensures everything works perfectly. We then deploy the solution with minimal disruption to your operations.",
      duration: "1-2 weeks"
    },
    {
      icon: <FaChartBar />,
      number: "05",
      title: "Monitoring & Optimization",
      description: "We continuously monitor performance, gather feedback, and optimize the system to ensure maximum efficiency and ROI.",
      duration: "Ongoing"
    }
  ];

  return (
    <section id="process" className="section process" ref={ref}>
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: -50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2>Our Process</h2>
          <p>A proven methodology that delivers results every time</p>
        </motion.div>

        <div className="process-timeline">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="process-step"
              initial={{ opacity: 0, x: index % 2 === 0 ? -100 : 100 }}
              animate={inView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.15 }}
            >
              <div className={`step-content ${index % 2 === 0 ? 'left' : 'right'}`}>
                <motion.div 
                  className="step-card glass"
                  whileHover={{ 
                    scale: 1.05,
                    y: -10,
                    transition: { duration: 0.3 }
                  }}
                >
                  <div className="step-header">
                    <motion.div 
                      className="step-icon"
                      whileHover={{ rotate: 360 }}
                      transition={{ duration: 0.6 }}
                    >
                      {step.icon}
                    </motion.div>
                    <span className="step-number">{step.number}</span>
                  </div>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                  <div className="step-duration">
                    <span>{step.duration}</span>
                  </div>
                </motion.div>
              </div>
              
              {index < steps.length - 1 && (
                <motion.div 
                  className="timeline-connector"
                  initial={{ scaleY: 0 }}
                  animate={inView ? { scaleY: 1 } : {}}
                  transition={{ duration: 0.6, delay: index * 0.15 + 0.3 }}
                />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
